import { useEffect, useState } from 'react';
import { fetchWasteCustomerDetails } from '../api/waste-customer-details';

export const useWasteCustomerDetails = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        fetchWasteCustomerDetails()
            .then((mapped) => {
                if (cancelled)
                    return;

                setData(mapped);
                setError(null);
            })
            .catch((err) => {
                console.error('Failed to load waste customer details', err);
                if (!cancelled) setError(err || new Error('Failed to load'));
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return { data, loading, error };
};